import { h, Component } from 'preact';
import cx from 'classnames';

import { CLEAR_FOCUSED_LISTING, ListingAction } from './reducers/listing/listing.actions';
import { hopplerApi } from '../../constants';
import { BUSINESS_GROUP } from '../../constants/roles';

import * as roles from '../core/roles';

import { Navbar } from './components/common/navbar.component';
import { KumitaDashboard } from './components/dashboard.component';
import { PreactTester } from './components/zzdevelopment/preact-tester.component';

import { GET_CURRENT_USER, LOGOUT } from './reducers/user/user.actions';
import getStore, { appState$ } from './store';
import { PostProperty } from './components/post-property.component';
import { DashListings } from './components/dash-listings.component';
import { PropertyPage } from './components/propertypreview/property-page';
import { map, distinctUntilChanged } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { User, Listing } from '../../types';

import Router from 'preact-router';
import { PropertyPreview } from './components/propertypreview/property-preview.component';
import { CommissionAgreement } from './components/static/commission-agreement.component';
import { Events } from './components/static/events.component';
import { Rewards } from './components/static/rewards.component';
import { GRAY_PIXEL } from '../../constants/color-pixels';
import { navigatorGo } from '../utils/navigator';
import { Group } from '../../types/group.model';
import { GroupListings } from './components/group-listings.component';
import { InquiryGridPage } from './components/inquiries/grid/inquiry-grid-page.component';
import { InquiryGridPageIndex } from './components/inquiries/grid/inquiry-grid-page-index.component';
import { InquiryGridModals } from './components/inquiries/grid/inquiry-grid-modals.component';
import { DealsLostPage } from './components/dealslost/deals-lost-dashboard';


interface KumitaAppState {
  isSidenavVisible?: boolean;
  currentUser?: User;
  currentRoute?: string;
  listingTabVisible?: boolean;
  focusedListing?: Listing;
  groups?: Group[];
}

export class PreactApp extends Component<any, KumitaAppState> {
  basePath: string = 'kumita-brokers';
  subs: Subscription[] = [];

  constructor(props) {
    super(props);

    this.setState({
      currentRoute: location.pathname,
    })
  }

  componentDidMount() {
    const user$ = appState$.pipe(
      map(app => app.user)
    );

    this.subs.push(
      user$.pipe(
        map(user => user.currentUser),
        distinctUntilChanged()
      ).subscribe(currentUser => {
        if (currentUser) {
          this.setState({
            currentUser: currentUser
          });
        }
      })
    );

    const listing$ = appState$.pipe(
      map(app => app.listing)
    );

    this.subs.push(
      listing$.pipe(
        map(listing => listing.focusedListing),
        distinctUntilChanged()
      ).subscribe(focusedListing => {
        this.setState({
          focusedListing: focusedListing
        });
      })
    );

    this.subs.push(
      user$.pipe(
        map(user => user.currentGroups)
      ).subscribe(groups => this.setState({ groups }))
    );
    
    this.initialStoreDispatches();
  }

  toggleListingTab = () => {
    const listingTabVisible = this.state.listingTabVisible;
    this.setState({
      listingTabVisible: !listingTabVisible
    })
  }

  initialStoreDispatches() {
    const action = {
      type: GET_CURRENT_USER
    }
  
    getStore().dispatch(action);
  }

  onSidenavClicked = () => {
    this.setState({
      isSidenavVisible: !this.state.isSidenavVisible
    });
  }

  onRouteChange = (e) => {
    if (this.state.focusedListing) {
      const store = getStore();
      const action: ListingAction = {
        type: CLEAR_FOCUSED_LISTING
      };

      store.dispatch(action);
    }

    this.setState({
      currentRoute: e.url,
      isSidenavVisible: false
    });


  }

  onLogout = () => {
    const action = {
      type: LOGOUT
    }
  
    getStore().dispatch(action);
  }

  isRouteActive = (routeName: string) => {
    // Include first part (currently "/kumita-brokers/") before comparing
    const prefix = '/kumita-brokers';

    // The dashboard page is /kumita-brokers and uses undefined as the route name.
    // Handle that special case by never leaving a trailing /
    const fullRoute = prefix + (routeName ? `/${routeName}` : '');
    const currentPath = this.state.currentRoute;

    const exactMatch = currentPath === fullRoute;
    const inChildRoute = routeName && currentPath.startsWith(fullRoute);

    return exactMatch || inChildRoute;
  }

  getUserPhotoPath(user: User): string {
    if (user && user.photo) {
      return `${hopplerApi.images}/${this.state.currentUser.photo}`;
    } else {
      return GRAY_PIXEL;
    }
  }

  getGroupListingsEntries(props, state: KumitaAppState) {
    if (state.groups) {
      return state.groups.map(group => (
        <li className={ cx('hi-kumita__sidenav__routes-list__item', {
          'active': this.isRouteActive(`group-listings/${group.profile}`),
          'bg-gainsboro': state.listingTabVisible
        })}>
          <a 
            className="listing-group__item"
            href={`/${this.basePath}/group-listings/${group.profile}`}>
            <div className="d-flex flex-column align-items-baseline">
              { this.getGroupName(group.name) }
            </div>
          </a>
        </li>
      ));
    }
  }

  getGroupName(name: string) {
    if (name == 'Others') {
      return <span className="d-block">Other Teams' Listings</span>
    } else {
      return <span className="d-block">Team Listings</span>
    }
  }

  render(props, state: KumitaAppState) {

    const { groups, listingTabVisible } = state;

    return (
      <div className="hi-kumita">

        <Navbar 
          currentUser={state.currentUser}
          sidenavMenuCallback={this.onSidenavClicked}
          currentRoute={state.currentRoute} 
          baseUrl={this.basePath} />

        <div className="hi-kumita__content">
          <div className="d-flex">
            <div className={ cx("hi-kumita__sidenav-container", 
                {
                  'visible': state.isSidenavVisible
                }
              )}>

              <div className="hi-kumita__sidenav">

                <div className="hi-kumita__sidenav__user">
                  <div className="hi-kumita__sidenav__user__img">
                    {
                      state.currentUser ? 
                        <img src={ this.getUserPhotoPath(state.currentUser) } alt=""/> :
                        null
                    }
                  </div>
                  <p className="hi-kumita__sidenav__user__name">
                    {
                      state.currentUser ? state.currentUser.fullName : null
                    }
                  </p>
                  <p className="hi-kumita__sidenav__user__type">
                    Partner Broker
                  </p>
                </div>

                <ul className="hi-kumita__sidenav__routes-list">
                  
                  <li className="hi-kumita__sidenav__routes-list__item d-md-none">
                    <button className='btn btn-link' href='#' onClick={ () => navigatorGo('/dashboard/mybusiness') }>
                      <i className="hi-kumita__sidenav__routes-list__item-icon fas fa-directions"></i>
                      <span className="hi-kumita__sidenav__routes-list__item-label">Go to Kumita V1</span>
                    </button>
                  </li>

                  <li className={ cx('hi-kumita__sidenav__routes-list__item', {
                      'active': this.isRouteActive(undefined)
                    })}
                    href={`/${this.basePath}`}>
                    <a href={`/${this.basePath}`}>
                      <i className="hi-kumita__sidenav__routes-list__item-icon fas fa-chart-line"></i>
                      <span className="hi-kumita__sidenav__routes-list__item-label">Dashboard</span>
                    </a>
                  </li>

                  { roles.isInGroup(state.currentUser, BUSINESS_GROUP) && (
                    <li className={ cx('hi-kumita__sidenav__routes-list__item', {
                        'active': this.isRouteActive('inquiries')
                      })}
                      href={`/${this.basePath}/inquiries/accepted`}>
                      <a href={`/${this.basePath}/inquiries/accepted`}>
                        <i className="hi-kumita__sidenav__routes-list__item-icon fas fa-filter"></i>
                        <span className="hi-kumita__sidenav__routes-list__item-label">Pipeline</span>
                      </a>
                    </li>
                  ) }

                  <li
                    onClick={ this.toggleListingTab }
                    className={ cx("hi-kumita__sidenav__routes-list__item", {
                      'bg-gainsboro': state.listingTabVisible
                    }) }
                    id="listing-wrapper">

                    <a>
                      <i className="hi-kumita__sidenav__routes-list__item-icon fas fa-home"></i>
                      <span className="hi-kumita__sidenav__routes-list__item-label">Listings
                        <i className={ cx("listing-tab__icon fas ml-1", {
                          'fa-chevron-up': this.state.listingTabVisible,
                          'fa-chevron-down': !this.state.listingTabVisible
                        }) }></i>
                      </span>
                    </a>
                  </li>
                                      
                  <ul className={ cx("pl-0 hi-kumita__sidenav__routes-list__listings", {
                    'listings-visible': listingTabVisible && groups,
                    'listings-visible-owner': listingTabVisible && !groups
                  }) }>

                    <li className={ cx('hi-kumita__sidenav__routes-list__item', {
                        'active': this.isRouteActive('listings'),
                        'bg-gainsboro': state.listingTabVisible
                      })}
                      href={`/${this.basePath}/listings`}>
                      <a 
                        className="listing-group__item"
                        href={`/${this.basePath}/listings`}>
                        My Listings
                      </a>
                    </li>

                    { this.getGroupListingsEntries(props, state) }
                  </ul>

                  <li className={ cx('hi-kumita__sidenav__routes-list__item', {
                      'active': this.isRouteActive('commission-agreement')
                    })}
                    href={`/${this.basePath}/commission-agreement`}>
                    <a href={`/${this.basePath}/commission-agreement`}>
                      <i className="hi-kumita__sidenav__routes-list__item-icon far fa-handshake"></i>
                      <span className="hi-kumita__sidenav__routes-list__item-label">Com. Agreement</span>
                    </a>
                  </li>

                  <li className={ cx('hi-kumita__sidenav__routes-list__item', {
                      'active': this.isRouteActive('deals-lost')
                    })}
                    href={`/${this.basePath}/deals-lost`}>
                    <a href={`/${this.basePath}/deals-lost`}>
                      <i className="hi-kumita__sidenav__routes-list__item-icon fas fa-briefcase"></i>
                      <span className="hi-kumita__sidenav__routes-list__item-label">Deals Lost</span>
                    </a>
                  </li>


                  <li className={ cx('hi-kumita__sidenav__routes-list__item', {
                      'active': this.isRouteActive('events')
                    })}
                    href={`/${this.basePath}/events`}>
                    <a href={`/${this.basePath}/events`}>
                      <i className="hi-kumita__sidenav__routes-list__item-icon fas fa-calendar-day"></i>
                      <span className="hi-kumita__sidenav__routes-list__item-label">Events</span>
                    </a>
                  </li>



                  <li className="hi-kumita__sidenav__routes-list__item"
                      onClick={this.onLogout}>
                    <a >
                      <i className="hi-kumita__sidenav__routes-list__item-icon fas fa-arrow-left"></i>
                      <span className="hi-kumita__sidenav__routes-list__item-label">Logout</span>
                    </a>
                  </li>
                </ul>
              </div>

            </div>
            <div className="hi-kumita__content__sidenav-padding d-none d-xl-block">
                {
                  /* Using Takumi's style for keeping floating objects
                  in a "relative" sense to others */
                 }
            </div>
          </div>
          

          <div className="hi-kumita__content__routes">
            <Router onChange={ this.onRouteChange }>
              <KumitaDashboard path={`${this.basePath}/`}/>
              <PostProperty path={`${this.basePath}/post-property`} />
              <DashListings path={`${this.basePath}/listings`} />

              <InquiryGridPageIndex path={`${this.basePath}/inquiries`} />
              <InquiryGridPage path={`${this.basePath}/inquiries/:stage`} />
             
              <GroupListings path={`${this.basePath}/group-listings/:group`} />
              <DealsLostPage path={`${this.basePath}/deals-lost`}/>

              <PreactTester path={`${this.basePath}/test`}/>
              <KumitaDashboard path="/"/>
              <PreactTester path="/test"/>

              <PropertyPreview path={`${this.basePath}/propertypreview`}/>

              <CommissionAgreement path={`${this.basePath}/commission-agreement`}/>
              <Events path={`${this.basePath}/events`}/>
              {/* <Rewards path={`${this.basePath}/rewards`}/> */}
            </Router>
            <InquiryGridModals />
          </div>
        </div>

        
      </div>
    );
  }
}